import { PromotionApproveSection } from './PromotionApproveSection'
import { withPromotionApproveSection } from './withPromotionApproveSection'

const ConnectedPromotionApproveSection = withPromotionApproveSection(
  PromotionApproveSection
)

export { ConnectedPromotionApproveSection as PromotionApproveSection }
